<template>
  <div>
    <div class="bg-white rounded-xl max-h-screen p-3 container desktop">
      <div class="flex flex-col gap-2">
        <inertia-link :class="{ 'link-active': isUrl('') }" :href="route('dashboard')">
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="dashboard"
              :class="isUrl('') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              class="w-5 h-5"
            />
            <div :class="isUrl('') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
              Fluxo turístico
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :href="route('indicators')"
          v-if="hasPerm('indicators-dash')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon name="indicator" class="w-5 h-5 fill-gray-700 group-hover:fill-white" />
            <div class="text-gray-600 group-hover:text-white">Dashboard de Indicadores</div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('indicators') }"
          :href="route('indicators.register')"
          v-if="hasPerm('indicators-dash')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="passport"
              class="w-5 h-5"
              :class="isUrl('indicators') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div
              :class="isUrl('indicators') ? 'text-white' : 'text-gray-600 group-hover:text-white'"
            >
              Cadastro de Indicadores
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('campaigns') }"
          :href="route('campaigns')"
          v-if="hasPerm('campaign-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="store-front"
              class="w-5 h-5"
              :class="isUrl('campaigns') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div
              :class="isUrl('campaigns') ? 'text-white' : 'text-gray-600 group-hover:text-white'"
            >
              Campanhas
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('qrcodes') }"
          :href="route('qrcodes')"
          v-if="hasPerm('qrcode-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="qr-code"
              class="w-5 h-5"
              :class="isUrl('qrcodes') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div :class="isUrl('qrcodes') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
              QRCodes
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('users') }"
          :href="route('users')"
          v-if="hasPerm('user-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="users"
              class="w-5 h-5"
              :class="isUrl('users') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div :class="isUrl('users') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
              Usuários
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('organizations') }"
          :href="route('organizations')"
          v-if="hasPerm('organization-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="office"
              class="w-5 h-5"
              :class="
                isUrl('organizations') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'
              "
            />
            <div
              :class="
                isUrl('organizations') ? 'text-white' : 'text-gray-600 group-hover:text-white'
              "
            >
              Organizações
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('roles') }"
          :href="route('roles')"
          v-if="hasPerm('role-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="book"
              class="w-5 h-5"
              :class="isUrl('roles') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div :class="isUrl('roles') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
              Papéis
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('map') }"
          :href="route('map')"
          v-if="hasPerm('campaign-list') || hasPerm('qrcode-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="map"
              class="w-5 h-5"
              :class="isUrl('map') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div :class="isUrl('map') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
              Mapa
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('questionnaires') }"
          :href="route('questionnaires')"
          v-if="hasPerm('questionnaires-read')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="questionnaires"
              class="w-5 h-5"
              :class="
                isUrl('questionnaires') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'
              "
            />
            <div
              :class="
                isUrl('questionnaires') ? 'text-white' : 'text-gray-600 group-hover:text-white'
              "
            >
              Questionários
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('rules') }"
          :href="route('rules')"
          v-if="hasPerm('rules-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="network"
              class="w-5 h-5"
              :class="isUrl('rules') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div :class="isUrl('rules') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
              Regras
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('actions') }"
          :href="route('actions')"
          v-if="hasPerm('rules-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="request"
              class="w-5 h-5"
              :class="isUrl('actions') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div :class="isUrl('actions') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
              Ações
            </div>
          </div>
        </inertia-link>

        <inertia-link
          class="flex items-center group hover:bg-indigo-prot w-full"
          :class="{ 'bg-indigo-prot': isUrl('integrations') }"
          :href="route('integrations')"
          v-if="hasPerm('rules-list')"
        >
          <div class="flex justify-start items-center gap-3 p-3 rounded-md">
            <icon
              name="request"
              class="w-5 h-5"
              :class="isUrl('integrations') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
            />
            <div :class="isUrl('integrations') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
              Integrações
            </div>
          </div>
        </inertia-link>

      </div>     
    </div>
    <div class="mobile">
      <div class="w-10 h-10 relative" @click="showMenu = !showMenu">
        <svg
          class="fill-gray-500 w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>

        <div class="menu-mobile" v-if="showMenu">
          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'link-active': isUrl('') }"
            :href="route('dashboard')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="dashboard"
                :class="isUrl('') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
                class="w-4 h-4"
              />
              <div :class="isUrl('') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
                <p class="unselectable">Dashboard</p>
              </div>
            </div>
          </inertia-link>
          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :href="route('indicators')"
            v-if="hasPerm('indicators-dash')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon name="indicator" class="w-4 h-4 fill-gray-700 group-hover:fill-white" />
              <div class="text-gray-600 group-hover:text-white">
                <p class="unselectable">Dashboard de Indicadores</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('indicators') }"
            :href="route('indicators.register')"
            v-if="hasPerm('indicators-dash')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="passport"
                class="w-4 h-4"
                :class="isUrl('indicators') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div
                :class="isUrl('indicators') ? 'text-white' : 'text-gray-600 group-hover:text-white'"
              >
                <p class="unselectable">Cadastro de Indicadores</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('campaigns') }"
            :href="route('campaigns')"
            v-if="hasPerm('campaign-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="store-front"
                class="w-4 h-4"
                :class="isUrl('campaigns') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div
                :class="isUrl('campaigns') ? 'text-white' : 'text-gray-600 group-hover:text-white'"
              >
                <p class="unselectable">Campanhas</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('qrcodes') }"
            :href="route('qrcodes')"
            v-if="hasPerm('qrcode-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="qr-code"
                class="w-4 h-4"
                :class="isUrl('qrcodes') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div
                :class="isUrl('qrcodes') ? 'text-white' : 'text-gray-600 group-hover:text-white'"
              >
                <p class="unselectable">QRCodes</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('users') }"
            :href="route('users')"
            v-if="hasPerm('user-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="users"
                class="w-4 h-4"
                :class="isUrl('users') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div :class="isUrl('users') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
                <p class="unselectable">Usuários</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('organizations') }"
            :href="route('organizations')"
            v-if="hasPerm('organization-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="office"
                class="w-4 h-4"
                :class="
                  isUrl('organizations') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'
                "
              />
              <div
                :class="
                  isUrl('organizations') ? 'text-white' : 'text-gray-600 group-hover:text-white'
                "
              >
                <p class="unselectable">Organizações</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('roles') }"
            :href="route('roles')"
            v-if="hasPerm('role-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="book"
                class="w-4 h-4"
                :class="isUrl('roles') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div :class="isUrl('roles') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
                <p class="unselectable">Papéis</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('map') }"
            :href="route('map')"
            v-if="hasPerm('campaign-list') || hasPerm('qrcode-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="map"
                class="w-4 h-4"
                :class="isUrl('map') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div :class="isUrl('map') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
                <p class="unselectable">Mapa</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('questionnaires') }"
            :href="route('questionnaires')"
            v-if="hasPerm('questionnaires-read')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="questionnaires"
                class="w-4 h-4"
                :class="
                  isUrl('questionnaires') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'
                "
              />
              <div
                :class="
                  isUrl('questionnaires') ? 'text-white' : 'text-gray-600 group-hover:text-white'
                "
              >
                <p class="unselectable">Questionários</p>
              </div>
            </div>
          </inertia-link>
          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('rules') }"
            :href="route('rules')"
            v-if="hasPerm('rules-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="network"
                class="w-4 h-4"
                :class="isUrl('rules') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div :class="isUrl('rules') ? 'text-white' : 'text-gray-600 group-hover:text-white'">
                <p class="unselectable">Regras</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('actions') }"
            :href="route('actions')"
            v-if="hasPerm('rules-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="request"
                class="w-4 h-4"
                :class="isUrl('actions') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div
                :class="isUrl('actions') ? 'text-white' : 'text-gray-600 group-hover:text-white'"
              >
                <p class="unselectable">Ações</p>
              </div>
            </div>
          </inertia-link>

          <inertia-link
            class="flex items-center group hover:bg-indigo-prot w-full"
            :class="{ 'bg-indigo-prot': isUrl('integrations') }"
            :href="route('integrations')"
            v-if="hasPerm('rules-list')"
          >
            <div class="flex justify-start items-center gap-3 p-3 rounded-md">
              <icon
                name="request"
                class="w-4 h-4"
                :class="isUrl('integrations') ? 'fill-white' : 'fill-gray-700 group-hover:fill-white'"
              />
              <div
                :class="isUrl('integrations') ? 'text-white' : 'text-gray-600 group-hover:text-white'"
              >
                <p class="unselectable">Integrações</p>
              </div>
            </div>
          </inertia-link>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  data() {
    return {
      showMenu: false,
    }
  },
  methods: {
    isUrl(url) {
      const current = this.$page.url.substr(1)

      if (url === '') {
        return current === ''
      }

      return current.startsWith(url)
    },
    hasPerm(perm) {
      return this.$page.props.auth.user.roles.includes(perm)
    },
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick)
  },
}
</script>

<style scoped>
.link-active {
  background-color: #e6e9eb;
}

.container {
  height: 98vh;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
}

.mobile {
  display: none;
}

.menu-mobile {
  position: absolute;
  top: 50px;
  background-color: #fff;
  width: 180px;
  height: max-content;
  z-index: 10;
  border-radius: 12px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  user-select: none;
}

.unselectable {
  user-select: none;
}

@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }
}
</style>
